import { render, staticRenderFns } from "./StorageUsageTop.vue?vue&type=template&id=0f492b38"
import script from "./StorageUsageTop.vue?vue&type=script&lang=js"
export * from "./StorageUsageTop.vue?vue&type=script&lang=js"
import style0 from "./StorageUsageTop.vue?vue&type=style&index=0&id=0f492b38&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports